import { PAGEPATHS } from "../../components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useParams } from "react-router-dom" //
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";
import "./Uswds.css";
import {
  Shield,
  Palette,
  FileText,
  Info,
  CheckCircle,
  XCircle,
  Loader,
  Database
} from 'lucide-react';

const UsWebDesignStd = (props) => {
    document.title = "US Web Design Standards";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [uswds2Data, setUswds2Data] = useState({})

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "US Web Design Standards", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("US Web Design Standards", breadcrumbItems)
    })

    useEffect(() => {
        const getUsWebDesignStdData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_USWDS2_SCAN}/${scanId}`)
                const valid = Object.entries(data.data).reduce((a, v) => {
                    a.columns.push({
                        label: v[0],
                        field: v[0],
                        sort: 'asc',
                        width: 150
                    })
                    if (typeof v[1] === 'boolean' || v[1] === 0) {
                        a.rows[0][v[0]] = v[1].toString()
                    } else if (v[1] === null) {
                        a.rows[0][v[0]] = 'NaN'
                    } else {
                        a.rows[0][v[0]] = v[1]
                    }
                    return a
                }, { columns: [], rows: [{}] })
                setUswds2Data(valid)
            } catch (e) {
                console.error(e);
            }
        }
        getUsWebDesignStdData()
    }, [scanId])

    return (
        <React.Fragment>
            <div className="uswds-page">
                {/* Page Header */}
                <div className="uswds-header">
                    <div className="uswds-header-content">
                        <div className="uswds-icon-wrapper">
                            <Palette className="uswds-icon" />
                        </div>
                        <div className="uswds-header-text">
                            <h1>U.S. Web Design System (USWDS)</h1>
                            <p>Design standards compliance and implementation analysis for {sessionStorage.getItem('domain')}</p>
                        </div>
                    </div>
                </div>

                {/* Info Section */}
                <div className="uswds-info-section">
                    <div className="uswds-info-header">
                        <div className="info-icon-wrapper">
                            <Info className="info-icon" />
                        </div>
                        <h3>About USWDS</h3>
                    </div>
                    <div className="uswds-info-content">
                        <p>
                            The U.S. Web Design System (USWDS) is a design system for the federal government.
                            It helps federal agencies create consistent, accessible, and user-friendly websites.
                        </p>
                        <p>
                            This scan checks your website's compliance with USWDS standards, including design patterns,
                            components, and accessibility requirements.
                        </p>
                    </div>
                </div>

                {/* Standards Overview */}
                {uswds2Data && uswds2Data.rows && uswds2Data.rows.length > 0 && (
                    <div className="uswds-standards-grid">
                        {/* Total Standards Checked */}
                        <div className="standard-card">
                            <div className="standard-card-header">
                                <div className="standard-icon-wrapper blue">
                                    <Database className="standard-icon blue" />
                                </div>
                                <h4>Standards Checked</h4>
                            </div>
                            <div className="standard-card-value">
                                {uswds2Data.columns ? uswds2Data.columns.length : 0}
                            </div>
                            <div className="standard-card-description">
                                Total design standards evaluated
                            </div>
                        </div>

                        {/* Compliance Status */}
                        <div className="standard-card">
                            <div className="standard-card-header">
                                <div className="standard-icon-wrapper green">
                                    <CheckCircle className="standard-icon green" />
                                </div>
                                <h4>Scan Status</h4>
                            </div>
                            <div className="standard-card-value">
                                <div className="status-badge success">
                                    <CheckCircle className="status-badge-icon" />
                                    <span>Completed</span>
                                </div>
                            </div>
                            <div className="standard-card-description">
                                Scan completed successfully
                            </div>
                        </div>

                        {/* Scan Details */}
                        <div className="standard-card">
                            <div className="standard-card-header">
                                <div className="standard-icon-wrapper blue">
                                    <FileText className="standard-icon blue" />
                                </div>
                                <h4>Scan ID</h4>
                            </div>
                            <div className="standard-card-value" style={{ fontSize: '1rem', wordBreak: 'break-all' }}>
                                {scanId}
                            </div>
                            <div className="standard-card-description">
                                Unique scan identifier
                            </div>
                        </div>
                    </div>
                )}

                {/* Data Table Section */}
                <div className="uswds-data-section">
                    <div className="uswds-section-header">
                        <Shield className="section-header-icon" />
                        <h2>USWDS 2.0 Standards Compliance</h2>
                        <span className="scan-id">Scan ID: {scanId}</span>
                    </div>
                    {uswds2Data && uswds2Data.rows && uswds2Data.rows.length > 0 ? (
                        <DataTableWithPopup noBottomColumns thirdPartyData={uswds2Data} />
                    ) : (
                        <div className="uswds-empty-state">
                            <Palette className="uswds-empty-icon" />
                            <p>No USWDS scan data available for this scan</p>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(UsWebDesignStd)